<template>
  <v-container class="ma-0 pa-0">
    <v-card elevation="0" class="ma-0 pa-0">
      <v-toolbar color="secondary" flat>
        <v-toolbar-title class="white--text">License Purchased</v-toolbar-title>
      </v-toolbar>
      <v-container>
        <v-container class="ma-0 px-0 py-4">
          Thank you purchasing a license for Beyond Labz!
          Please visit the license page to verify your license is active.
        </v-container>
        <v-row class="ma-0 pa-0">
          <v-btn elevation="0" color="primary" @click="$router.push('/license')">License</v-btn>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'LicensePurchased',
};
</script>

<style scoped>

</style>
